import {
    AbsoluteModelPath,
    emptyAbsoluteModelPath,
    joinModelPaths,
    ModelPath,
    PathToken,
    ResolvedModelPath,
} from "./ModelPath";

export class ModelPathBuilder {
    private readonly parts: Array<ModelPath | PathToken>;

    public constructor(forceAbsolute: boolean = false) {
        this.parts = forceAbsolute ? [emptyAbsoluteModelPath()] : [];
    }

    public get empty(): boolean {
        return this.parts.length === 0;
    }

    public append(pathPart: ModelPath | PathToken | Array<ModelPath | PathToken>): this {
        if (Array.isArray(pathPart)) {
            this.parts.push(...pathPart);
        } else {
            this.parts.push(pathPart);
        }
        return this;
    }

    public toPath(): ModelPath {
        return joinModelPaths(...this.parts);
    }

    public toResolvedPath(): ResolvedModelPath {
        const result = this.toPath();
        if (!result.isResolved()) {
            throw new Error("Path cannot be casted to resolved");
        }
        return result;
    }

    public toAbsolutePath(): AbsoluteModelPath {
        return this.toPath().toAbsolute();
    }

    public toString(): string {
        return this.toPath().toString();
    }
}
